import { A } from '@ember/array';
import { computed } from '@ember/object';
export default function isAny(collectionProperty, property, value) {
  return computed(`${collectionProperty}.@each.${property}`, function () {
    const dependentValue = this.get(collectionProperty);
    if (value === undefined) {
      return dependentValue && A(dependentValue).isAny(property);
    } else {
      return dependentValue && A(dependentValue).isAny(property, value);
    }
  });
}